import React from 'react';
import { IconProps } from './types';

const RetryIconOutline: React.FC<IconProps> = props => {
  const { className, size = 16, fillColor = '#969696', onClick } = props;
  return (
    <svg
      onClick={onClick}
      className={className}
      width={size}
      height={size}
      viewBox={`"0 0 ${size} ${size}"`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_12577_140161"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width={size}
        height={size}
      >
        <rect width={size} height={size} fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_12577_140161)">
        <path
          d="M7.83822 13.3151C6.34933 13.3151 5.08822 12.7984 4.05488 11.7651C3.02155 10.7318 2.50488 9.47066 2.50488 7.98177C2.50488 6.49288 3.02155 5.23177 4.05488 4.19844C5.08822 3.1651 6.34933 2.64844 7.83822 2.64844C8.60488 2.64844 9.33822 2.80688 10.0382 3.12377C10.7382 3.44022 11.3382 3.89288 11.8382 4.48177V3.3151C11.8382 2.94691 12.1367 2.64844 12.5049 2.64844C12.8731 2.64844 13.1715 2.94691 13.1715 3.3151V6.3151C13.1715 6.86739 12.7238 7.3151 12.1715 7.3151H9.17155C8.80336 7.3151 8.50488 7.01663 8.50488 6.64844C8.50488 6.28025 8.80336 5.98177 9.17155 5.98177H11.3049C10.9493 5.35955 10.4633 4.87066 9.84688 4.5151C9.22999 4.15955 8.56044 3.98177 7.83822 3.98177C6.72711 3.98177 5.78266 4.37066 5.00488 5.14844C4.22711 5.92622 3.83822 6.87066 3.83822 7.98177C3.83822 9.09288 4.22711 10.0373 5.00488 10.8151C5.78266 11.5929 6.72711 11.9818 7.83822 11.9818C8.69377 11.9818 9.46599 11.7373 10.1549 11.2484C10.7156 10.8505 11.1401 10.3496 11.4284 9.74557C11.5485 9.49411 11.7917 9.3151 12.0703 9.3151C12.5425 9.3151 12.8884 9.76501 12.6943 10.1955C12.3401 10.9812 11.8103 11.6489 11.1049 12.1984C10.1493 12.9429 9.06044 13.3151 7.83822 13.3151Z"
          fill={fillColor}
        />
      </g>
    </svg>
  );
};

export default RetryIconOutline;
